// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".title[data-v-79225e3c] {\n  text-align: center;\n  font-weight: bold;\n  font-size: 1.4rem;\n}\n.discount[data-v-79225e3c] {\n  font-weight: bold;\n  font-size: 2.4rem;\n  color: #c67cd2;\n  text-align: center;\n  margin-bottom: 1.8rem;\n}\n.btn-color-gray[data-v-79225e3c] {\n  margin-top: 0.7rem;\n}", ""]);
// Exports
module.exports = exports;
